import requisicaoSegura from '@/auth/requisicaoSegura';
import requestFirebase from '@/config/firebaseConfig';
import { APIResponseFichaAdicional } from './types/ficha';
import { Ficha } from '@/types/ficha';
import { PlataformaStreaming } from '@/types/plataformaStreaming';

export async function recuperarFichaAdicional(
  id: string,
): Promise<APIResponseFichaAdicional> {
  const responseRecuperarFichaAdicional: APIResponseFichaAdicional =
    await requisicaoSegura({
      endpoint: '/Titulo/MeusDados',
      dataForm: {
        tituloID: id,
      },
    });

  return responseRecuperarFichaAdicional;
}

export async function recuperarFichaPorID(id: string): Promise<Ficha> {
  const ficha = await requestFirebase<Ficha[]>({
    colecao: 'titulo',
    filtros: [
      ['tituloID', '==', id],
      ['lingua', '==', 'padrao'],
    ],
  });

  return ficha?.[0];
}

export async function recuperarFichaPorSlug(slug: string): Promise<Ficha> {
  const ficha = await requestFirebase<Ficha[]>({
    colecao: 'titulo',
    filtros: [
      ['slug', '==', slug],
      ['lingua', '==', 'padrao'],
    ],
  });

  return ficha?.[0];
}

export async function recuperarPlataformaCinema(): Promise<PlataformaStreaming> {
  const plataformasStreaming = await requestFirebase<PlataformaStreaming[]>({
    colecao: 'plataformaStreaming',
    filtros: [
      ['ativo', '==', true],
      ['paisID', '==', '55'],
      ['permiteAssinatura', '==', false],
      ['plataformaStreamingID', '==', '343054bd-81cc-ec11-ab22-02dc6c46bf69'],
    ],
  });

  return plataformasStreaming?.[0];
}
